import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faMobileAlt, faCar, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

type InfoModalParkingModeProps = {
    closeModal: Function
}

const InfoModalParkingMode: FC<InfoModalParkingModeProps> = ({ closeModal }) => (
    <div className="info-modal panel big radius-rectangle">
        <div className="panel-header">
            <h2 className="bold-title">
                <FontAwesomeIcon icon={faInfoCircle} />
                <FormattedMessage id="INFO_MODAL_TITLE_PARKING_MODE" />
            </h2>
            <button className="btn-close-modal" onClick={() => closeModal()} />
        </div>
        <div className="panel-content">
            <div className="modal-content align-left">
                <table className="tbl-invisible-with-celpadding">
                    <tbody>
                        <tr>
                            <td>
                                <div className="bold">
                                    <FormattedMessage id="PARKING_MODE_MANUAL" />
                                </div>
                                <FontAwesomeIcon icon={faMobileAlt} className="fa-icon" />
                            </td>
                            <td>
                                <FormattedMessage id="PARKING_MODE_MANUAL_EXPLAINED" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className="bold nowrap">
                                    <FormattedMessage id="PARKING_MODE_SEMI_AUTOMATIC" />
                                </div>
                                <FontAwesomeIcon icon={faMobileAlt} className="fa-icon" />
                                <FontAwesomeIcon icon={faCar} className="fa-icon" />
                            </td>
                            <td>
                                <FormattedMessage id="PARKING_MODE_SEMI_AUTOMATIC_EXPLAINED" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className="bold">
                                    <FormattedMessage id="PARKING_MODE_AUTOMATIC" />
                                </div>
                                <FontAwesomeIcon icon={faCar} className="fa-icon" />
                                <FontAwesomeIcon icon={faMobileAlt} className="fa-icon" />
                            </td>
                            <td>
                                <FormattedMessage id="PARKING_MODE_AUTOMATIC_EXPLAINED" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className="bold">
                                    <FormattedMessage id="PARKING_MODE_AUTONOMOUS" />
                                </div>
                                <FontAwesomeIcon icon={faCar} className="fa-icon" />
                            </td>
                            <td>
                                <FormattedMessage id="PARKING_MODE_AUTONOMOUS_EXPLAINED" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className="bold">
                                    <FormattedMessage id="PARKING_MODE_MANUAL_SHARED" />
                                </div>
                                <FontAwesomeIcon icon={faUserFriends} className="fa-icon" />
                                <FontAwesomeIcon icon={faMobileAlt} className="fa-icon" />
                            </td>
                            <td>
                                <FormattedMessage id="PARKING_MODE_MANUAL_SHARED_EXPLAINED" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className="bold">
                                    <FormattedMessage id="PARKING_MODE_SHARED" />
                                </div>
                                <FontAwesomeIcon icon={faUserFriends} className="fa-icon" />
                                <FontAwesomeIcon icon={faMobileAlt} className="fa-icon" />
                                <FontAwesomeIcon icon={faCar} className="fa-icon" />
                            </td>
                            <td>
                                <FormattedMessage id="PARKING_MODE_SHARED_EXPLAINED" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
);

export default InfoModalParkingMode;
